import React, { useState, useEffect } from 'react';

import '../styles/Navbar.css';
import '../styles/Responsive.css';

import { MdCalendarToday, MdSearch, MdClose, MdMenu } from "react-icons/md";
import { Link } from 'react-router-dom';
import EventsModal from '../components/EventsModal';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [eventsModalOpen, setEventsModalOpen] = useState(false);
  
  // Check if screen width is mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };
    
    // Initial check
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    
    // Prevent scrolling when menu is open
    if (!mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };
  
  // Close mobile menu when a link is clicked
  const handleLinkClick = () => {
    setMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };
  
  return (
    <div className='nav-wrapper'>
        {/* Top Row: Logo + Menu/Search Icons */}
        <div className='nav-top-row'>
          <Link className='nav-logo-container' to={'/'}>
              <img src={process.env.PUBLIC_URL + '/assets/logo.png'} className='nav-logo'/>
          </Link>
          
          <div className='nav-options-container'>
            {isMobile ? (
              <div className='nav-option' onClick={toggleMobileMenu}>
                {mobileMenuOpen ? 
                  <MdClose size={25} color='#2c2c2c'/> : 
                  <MdMenu size={25} color='#2c2c2c'/>
                }
              </div>
            ) : (
              <>
                <div className='nav-events-button' onClick={() => setEventsModalOpen(true)}>
                  <MdCalendarToday size={22} color='#2c2c2c'/>
                  <span className='nav-events-text'>Events</span>
                </div>
                <div className='nav-option' style={{marginLeft: '20px'}}>
                  <MdSearch size={25} color='#2c2c2c' className='nav-option'/>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Bottom Row: Navigation Links (Desktop Only) */}
        {!isMobile && (
          <div className='nav-bottom-row'>
            <div className='nav-items-container'>
              <Link className='nav-item'>INSPIRATION</Link>
              <Link className='nav-item' to={'/destinations'}>DESTINATIONS</Link>
              <Link className='nav-item'>PLACES TO STAY</Link>
              <Link className='nav-item'>CRUISES</Link>
              <Link className='nav-item'>WELLNESS & SPIRITUALITY</Link>
              <Link className='nav-item' to={'/directory'}>DIRECTORY</Link>
              <Link className='nav-item' to={'/connectivity-tool'}>CONNECTIVITY TOOL</Link>
            </div>
          </div>
        )}
        
        {/* Mobile menu overlay */}
        {mobileMenuOpen && (
          <div className='mobile-menu-overlay'>
            <div className='mobile-menu-close' onClick={handleLinkClick}>
              <MdClose size={28} color='#2c2c2c'/>
            </div>
            <div className='mobile-menu-container'>
              <Link className='mobile-nav-item' to={'/'} onClick={handleLinkClick}>HOME</Link>
              <Link className='mobile-nav-item' onClick={handleLinkClick}>INSPIRATION</Link>
              <Link className='mobile-nav-item' to={'/destinations'} onClick={handleLinkClick}>DESTINATIONS</Link>
              <Link className='mobile-nav-item' onClick={handleLinkClick}>PLACES TO STAY</Link>
              <Link className='mobile-nav-item' onClick={handleLinkClick}>CRUISES</Link>
              <Link className='mobile-nav-item' onClick={handleLinkClick}>WELLNESS & SPIRITUALITY</Link>
              <Link className='mobile-nav-item' to={'/directory'} onClick={handleLinkClick}>DIRECTORY</Link>
              <Link className='mobile-nav-item' to={'/connectivity-tool'} onClick={handleLinkClick}>CONNECTIVITY TOOL</Link>
              <div className='mobile-nav-item' onClick={() => { setEventsModalOpen(true); handleLinkClick(); }}>EVENTS CALENDAR</div>
            </div>
          </div>
        )}
        
        {/* Events Modal */}
        <EventsModal 
          isOpen={eventsModalOpen} 
          onClose={() => setEventsModalOpen(false)} 
        />
    </div>
  )
}
